const Spinner = () => {
	return (
		<div className='d-flex'>
			<div className='spinner-border text-info' role='status'>
				<span className='visually-hidden'>Loading...</span>
			</div>
		</div>
	)
}

export default Spinner
